import { render } from "./RecognitionFeature.vue?vue&type=template&id=86b80068&scoped=true"
import script from "./RecognitionFeature.vue?vue&type=script&lang=js"
export * from "./RecognitionFeature.vue?vue&type=script&lang=js"

import "./RecognitionFeature.vue?vue&type=style&index=0&id=86b80068&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-86b80068"

export default script